import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Header, RoutesInternal } from 'theSource/components';
import { ForgotPasswordForm } from './components';
import { ForgotPasswordStyled, ModalStyled } from './ForgotPasswordStyled';
import {
  ChangePasswordForm,
  LumosChangePasswordForm,
} from './components/ChangePasswordForm';
import {
  useConfigurationQuery,
  useCompanySettingsQuery,
} from 'theSource/queries';
import { selectIsAdmin } from 'theSource/features';

export const ForgotPassword = () => {
  const { configuration } = useConfigurationQuery();
  const isAdmin = useSelector(selectIsAdmin);
  const { companySettings } = useCompanySettingsQuery({
    enabled: Boolean(configuration?.apiHost) && !isAdmin,
  });

  const lumosEnabled = companySettings?.data.lumos_feature_toggle;

  return (
    <ModalStyled open={true} data-testid="forgot-password-page">
      <>
        <Header hideDrawer />
        <ForgotPasswordStyled>
          <RoutesInternal>
            <Route path="/" element={<ForgotPasswordForm />} />
            <Route
              path="/change"
              element={
                lumosEnabled ? (
                  <LumosChangePasswordForm />
                ) : (
                  <ChangePasswordForm />
                )
              }
            />
          </RoutesInternal>
        </ForgotPasswordStyled>
      </>
    </ModalStyled>
  );
};
